(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-cart"]) return;
  try {
    
if (!customElements.get('sv-cart-page')) {
  customElements.define('sv-cart-page', class extends HTMLElement {
    connectedCallback() {
      if (this.events) return;
      this.events = new AbortController();
      const signal = this.events.signal;
      this.setAttribute('data-enhanced', '');
      this.addEventListener('click', event => {
        const control = event.target.closest('[data-quantity-step],[data-cart-remove]');
        if (!control) return;
        event.preventDefault();
        if (this.busy || this.stale || control.disabled) return;
        const row = control.closest('[data-cart-item]');
        const input = row.querySelector('[data-cart-quantity]');
        if (control.matches('[data-cart-remove]')) this.change(row, 0, 'remove');
        else {
          if (Number(control.dataset.quantityStep) > 0) input.stepUp(); else input.stepDown();
          if (input.reportValidity()) this.change(row, Number(input.value), control.dataset.quantityStep);
        }
      }, { signal });
      this.addEventListener('input', event => {
        const input = event.target.closest('[data-cart-quantity]');
        if (!input || this.busy || this.stale) return;
        clearTimeout(this.quantityTimer);
        this.pendingInput = input;
        this.querySelector('[data-cart-status]').textContent = input.validity.valid ? this.dataset.updating : '';
        this.quantityTimer = setTimeout(() => {
          if (input.validity.valid) this.change(input.closest('[data-cart-item]'), Number(input.value), 'input');
        }, 350);
      }, { signal });
      this.addEventListener('change', event => {
        const input = event.target.closest('[data-cart-quantity]');
        if (!input || this.busy || this.stale) return;
        if (input.reportValidity()) this.change(input.closest('[data-cart-item]'), Number(input.value), 'input');
      }, { signal });
      this.addEventListener('submit', event => {
        if (this.busy || this.stale || this.pendingInput || event.submitter?.name === 'update') {
          event.preventDefault();
          if (this.stale || event.submitter?.name !== 'checkout') return;
          this.checkoutRequested = true;
          if (!this.busy && this.pendingInput?.reportValidity()) {
            const input = this.pendingInput;
            this.change(input.closest('[data-cart-item]'), Number(input.value), 'input');
          }
        }
      }, { signal });
    }
    disconnectedCallback() { clearTimeout(this.quantityTimer); this.events?.abort(); this.events = null; }
    setBusy(busy) {
      this.busy = busy;
      this.setAttribute('aria-busy', String(busy));
      if (busy) {
        this.controls = [...this.querySelectorAll('input,button:not([data-cart-checkout])')].map(element => ({ element, disabled: element.disabled }));
        this.controls.forEach(({ element }) => { element.disabled = true; });
      } else {
        this.controls?.forEach(({ element, disabled }) => { element.disabled = disabled; });
        if (this.stale) this.querySelectorAll('input,button').forEach(element => { element.disabled = true; });
      }
    }
    showError(message, stale = false) {
      this.stale = stale;
      const error = this.querySelector('[data-cart-error]');
      error.textContent = message;
      error.hidden = false;
      this.querySelector('[data-cart-refresh]').hidden = !stale;
      this.querySelector('[data-cart-status]').textContent = '';
    }
    async readCurrent() {
      const url = new URL(this.dataset.cartUrl, window.location.origin);
      url.searchParams.set('section_id', this.dataset.sectionId);
      const responses = await Promise.all([
        fetch(this.dataset.cartUrl + '.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin', cache: 'no-store' }),
        fetch(url.toString(), { credentials: 'same-origin', cache: 'no-store' })
      ]);
      if (responses.some(response => !response.ok)) throw new Error('refresh');
      return { cart: await responses[0].json(), html: await responses[1].text() };
    }
    renderCart(cart, html, index, focus) {
      if (typeof html !== 'string' || !Number.isInteger(cart.item_count)) throw new Error('section');
      const parsed = new DOMParser().parseFromString(html, 'text/html');
      const content = parsed.querySelector('sv-cart-page [data-cart-content]');
      if (!content) throw new Error('section');
      this.querySelector('[data-cart-content]').replaceWith(document.importNode(content, true));
      document.querySelectorAll('.sv-cart-count').forEach(badge => { badge.textContent = String(cart.item_count); badge.hidden = cart.item_count === 0; });
      const rows = [...this.querySelectorAll('[data-cart-item]')];
      const row = rows[Math.min(index, rows.length - 1)];
      const selector = focus === 'input' ? '[data-cart-quantity]' : focus === 'remove' ? '[data-cart-remove]' : '[data-quantity-step="' + focus + '"]';
      const target = row?.querySelector(selector);
      (target && !target.disabled ? target : row?.querySelector('[data-cart-quantity]') || this.querySelector('h1'))?.focus({ preventScroll: true });
    }
    async change(row, quantity, focus) {
      if (this.busy || this.stale || !Number.isInteger(quantity) || quantity < 0) return;
      clearTimeout(this.quantityTimer);
      this.pendingInput = null;
      let updated = false;
      const index = Number(row.dataset.index);
      const key = row.dataset.key;
      this.querySelector('[data-cart-error]').hidden = true;
      this.querySelector('[data-cart-refresh]').hidden = true;
      this.querySelector('[data-cart-status]').textContent = this.dataset.updating;
      this.setBusy(true);
      try {
        const response = await fetch(this.dataset.changeUrl + '.js', {
          method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, credentials: 'same-origin',
          body: JSON.stringify({ id: key, quantity, sections: [this.dataset.sectionId], sections_url: this.dataset.cartUrl })
        });
        const cart = await response.json();
        if (!response.ok) {
          const fresh = await this.readCurrent();
          this.renderCart(fresh.cart, fresh.html, index, focus);
          this.showError(typeof cart.description === 'string' ? cart.description : this.dataset.updateError);
        } else {
          let html = cart.sections?.[this.dataset.sectionId];
          if (typeof html !== 'string') {
            const fresh = await this.readCurrent();
            this.renderCart(fresh.cart, fresh.html, index, focus);
          } else this.renderCart(cart, html, index, focus);
          this.querySelector('[data-cart-status]').textContent = this.dataset.updated;
          updated = true;
        }
      } catch {
        try {
          const fresh = await this.readCurrent();
          this.renderCart(fresh.cart, fresh.html, index, focus);
          this.showError(this.dataset.updateError);
        } catch { this.showError(this.dataset.refreshError, true); }
      } finally {
        this.setBusy(false);
        const continueCheckout = this.checkoutRequested && updated && !this.stale;
        this.checkoutRequested = false;
        if (continueCheckout) {
          const form = this.querySelector('[data-cart-form]');
          const checkout = this.querySelector('[data-cart-checkout]');
          if (form && checkout) form.requestSubmit(checkout);
        }
      }
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
if (!customElements.get('sv-product-page')) {
  customElements.define('sv-product-page', class extends HTMLElement {
    connectedCallback() {
      if (this.events) return;
      this.events = new AbortController();
      const signal = this.events.signal;
      this.media = [...this.querySelectorAll('[data-media-id]')];
      this.images = this.media.filter(item => item.dataset.mediaType === 'image');
      this.lightbox = this.querySelector('.sv-pdp__lightbox');
      this.cartDialog = this.querySelector('.sv-pdp__cart-dialog');
      this.sticky = this.querySelector('[data-sticky-buy]');
      this.addEventListener('click', event => this.onClick(event), { signal });
      this.addEventListener('change', event => {
        if (event.target.matches('input[data-option-value-id]')) this.changeOption(event.target);
        if (event.target.matches('select[data-option-select]')) this.changeOption(event.target.selectedOptions[0], event.target.id);
        if (event.target.matches('[name="quantity"]')) this.updateQuantity();
      }, { signal });
      this.addEventListener('submit', event => {
        if (event.target.matches('.sv-pdp__form')) this.addToCart(event);
      }, { signal });
      this.addEventListener('keydown', event => {
        if (this.lightbox?.open && ['ArrowLeft', 'ArrowRight'].includes(event.key)) {
          event.preventDefault(); this.moveLightbox(event.key === 'ArrowLeft' ? -1 : 1);
        }
      }, { signal });
      this.querySelectorAll('dialog').forEach(dialog => {
        dialog.addEventListener('close', () => document.body.classList.remove('sv-pdp-dialog-open'), { signal });
        dialog.addEventListener('click', event => {
          if (event.target !== dialog) return;
          const box = dialog.getBoundingClientRect();
          if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) dialog.close();
        }, { signal });
      });
      this.selectMedia(this.media.find(item => !item.hidden)?.dataset.mediaId || this.media[0]?.dataset.mediaId);
      this.querySelectorAll('[data-lightbox-step]').forEach(button => button.hidden = this.images.length < 2);
      this.updateQuantity();
      this.observeBuyButton();
      this.headerObserver = new ResizeObserver(() => {
        const height = document.querySelector('.sv-header')?.getBoundingClientRect().height || 80;
        this.style.setProperty('--pdp-offset', `${height + 18}px`);
      });
      const header = document.querySelector('.sv-header');
      if (header) this.headerObserver.observe(header);
      this.setAttribute('data-enhanced', '');
    }
    disconnectedCallback() {
      this.removeAttribute('data-enhanced');
      this.events?.abort(); this.events = null;
      this.optionRequest?.abort(); this.buyObserver?.disconnect(); this.headerObserver?.disconnect();
      this.querySelectorAll('dialog[open]').forEach(dialog => dialog.close());
      document.body.classList.remove('sv-pdp-sticky-visible', 'sv-pdp-dialog-open');
    }
    onClick(event) {
      const quote = event.target.closest('[data-product-quote]');
      if (quote) {
        const quantity = this.querySelector('[name="quantity"]');
        if (quantity && !quantity.reportValidity()) { event.preventDefault(); return; }
        const url = new URL(quote.href);
        url.searchParams.set('quantity', quantity?.value || '1');
        quote.href = url.toString();
        return;
      }
      const target = event.target.closest('button');
      if (!target || target.disabled) return;
      if (target.matches('[data-thumb-id]')) this.selectMedia(target.dataset.thumbId);
      if (target.matches('[data-gallery-step]')) {
        const index = this.media.findIndex(item => !item.hidden);
        this.selectMedia(this.media[(index + Number(target.dataset.galleryStep) + this.media.length) % this.media.length]?.dataset.mediaId);
      }
      if (target.matches('[data-open-image]')) {
        this.showImage(target.closest('[data-media-id]').dataset.mediaId);
        this.lightbox.showModal(); document.body.classList.add('sv-pdp-dialog-open');
      }
      if (target.matches('[data-close-dialog]')) target.closest('dialog').close();
      if (target.matches('[data-lightbox-step]')) this.moveLightbox(Number(target.dataset.lightboxStep));
      if (target.matches('[data-lightbox-zoom]')) {
        const enabled = target.getAttribute('aria-pressed') !== 'true';
        target.setAttribute('aria-pressed', String(enabled));
        this.querySelector('.sv-pdp__lightbox-image').classList.toggle('is-zoomed', enabled);
      }
      if (target.matches('[data-quantity-change]')) {
        const input = this.querySelector('[name="quantity"]');
        if (Number(target.dataset.quantityChange) > 0) input.stepUp(); else input.stepDown();
        this.updateQuantity();
      }
      if (target.matches('[data-sticky-submit]')) {
        const form = this.querySelector('.sv-pdp__form');
        if (form.reportValidity()) form.requestSubmit();
      }
    }
    selectMedia(id) {
      if (!id || !this.media.some(item => item.dataset.mediaId === id)) return;
      this.media.forEach(item => {
        if (item.dataset.mediaId !== id && !item.hidden) {
          item.querySelectorAll('video').forEach(video => video.pause());
          item.querySelectorAll('iframe').forEach(frame => {
            const source = frame.getAttribute('src');
            if (source) frame.setAttribute('src', source);
          });
          item.querySelector('model-viewer')?.pause?.();
        }
        item.hidden = item.dataset.mediaId !== id;
      });
      this.querySelectorAll('[data-thumb-id]').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.thumbId === id)));
      const count = this.querySelector('[data-gallery-count]');
      if (count) count.textContent = `${this.media.findIndex(item => item.dataset.mediaId === id) + 1} / ${this.media.length}`;
    }
    showImage(id) {
      const media = this.images.find(item => item.dataset.mediaId === id);
      if (!media) return;
      this.zoomMedia = id;
      const image = this.querySelector('[data-zoom-image]');
      image.src = media.querySelector('[data-full-src]').dataset.fullSrc;
      image.alt = media.querySelector('img').alt;
      this.querySelector('.sv-pdp__lightbox-image').classList.remove('is-zoomed');
      this.querySelector('[data-lightbox-zoom]').setAttribute('aria-pressed', 'false');
    }
    moveLightbox(step) {
      if (!this.images.length) return;
      const index = this.images.findIndex(item => item.dataset.mediaId === this.zoomMedia);
      const next = this.images[(index + step + this.images.length) % this.images.length];
      this.showImage(next.dataset.mediaId); this.selectMedia(next.dataset.mediaId);
    }
    updateQuantity() {
      const input = this.querySelector('[name="quantity"]');
      if (!input) return;
      const count = Number(input.value), min = Number(input.min || 1), max = input.max ? Number(input.max) : Infinity;
      this.querySelector('[data-quantity-change="-1"]').disabled = count <= min;
      this.querySelector('[data-quantity-change="1"]').disabled = count >= max;
      const quote = this.querySelector('[data-product-quote]');
      if (quote && input.validity.valid) {
        const url = new URL(quote.href);
        url.searchParams.set('quantity', input.value);
        quote.href = url.toString();
      }
    }
    observeBuyButton() {
      this.buyObserver?.disconnect();
      const button = this.querySelector('[data-add-to-cart]');
      if (!button) return;
      this.buyObserver = new IntersectionObserver(entries => {
        const entry = entries[0];
        const visible = !entry.isIntersecting && entry.boundingClientRect.bottom < 100;
        this.sticky.hidden = !visible;
        document.body.classList.toggle('sv-pdp-sticky-visible', visible);
      }, { rootMargin: '-100px 0px 0px 0px' });
      this.buyObserver.observe(button);
    }
    setError(message, uncertain = false) {
      const error = this.querySelector('[data-product-error]');
      error.textContent = message; error.hidden = false;
      this.querySelector('.sv-pdp__check-cart').hidden = !uncertain;
    }
    async changeOption(input, focusId = input.id) {
      if (this.adding) return;
      this.optionRequest?.abort();
      const controller = this.optionRequest = new AbortController();
      const quantity = this.querySelector('[name="quantity"]').value;
      const values = [...this.querySelectorAll('[data-option-value-id]:checked')].map(option => option.dataset.optionValueId);
      const url = new URL(input.dataset.productUrl || this.dataset.productUrl, document.baseURI);
      const currentUrl = new URL(location.href);
      if (currentUrl.searchParams.has('preview_theme_id')) url.searchParams.set('preview_theme_id', currentUrl.searchParams.get('preview_theme_id'));
      url.searchParams.set('option_values', values.join(','));
      if (url.pathname !== new URL(this.dataset.productUrl, document.baseURI).pathname) {
        location.assign(url.href); return;
      }
      url.searchParams.set('section_id', this.dataset.sectionId);
      this.selecting = true;
      this.querySelector('[data-purchase]').setAttribute('aria-busy', 'true');
      this.querySelector('[data-add-to-cart]').disabled = true;
      this.querySelector('[data-sticky-submit]').disabled = true;
      this.querySelector('[data-product-error]').hidden = true;
      try {
        const response = await fetch(url, { signal: controller.signal });
        if (!response.ok) throw new Error('Section request failed');
        const parsed = new DOMParser().parseFromString(await response.text(), 'text/html');
        const next = [...parsed.querySelectorAll('sv-product-page')].find(item => item.dataset.sectionId === this.dataset.sectionId);
        const purchase = next?.querySelector('[data-purchase]');
        if (!purchase || !purchase.querySelector('.sv-pdp__form')) throw new Error('Missing product section');
        if (controller !== this.optionRequest || !this.isConnected) return;
        this.querySelector('[data-purchase]').replaceWith(purchase);
        const nextSticky = next.querySelector('[data-sticky-buy]');
        this.sticky.innerHTML = nextSticky.innerHTML;
        const quantityInput = this.querySelector('[name="quantity"]');
        const min = Number(quantityInput.min || 1), step = Number(quantityInput.step || 1), max = quantityInput.max ? Number(quantityInput.max) : Infinity;
        quantityInput.value = String(Math.min(max, min + Math.max(0, Math.floor((Number(quantity) - min) / step)) * step));
        const sku = this.querySelector('[data-spec-sku]');
        if (sku) { sku.hidden = !purchase.dataset.variantSku; sku.querySelector('dd').textContent = purchase.dataset.variantSku; }
        this.selectMedia(purchase.dataset.variantMedia);
        const displayUrl = new URL(location.href);
        displayUrl.searchParams.delete('option_values');
        if (purchase.dataset.variantId) displayUrl.searchParams.set('variant', purchase.dataset.variantId);
        else { displayUrl.searchParams.delete('variant'); displayUrl.searchParams.set('option_values', values.join(',')); }
        history.replaceState({}, '', displayUrl.href);
        this.updateQuantity(); this.observeBuyButton();
        document.getElementById(focusId)?.focus({ preventScroll: true });
      } catch (error) {
        if (error.name !== 'AbortError' && controller === this.optionRequest) {
          this.setError(this.dataset.optionError);
          this.querySelector('[data-purchase]').removeAttribute('aria-busy');
        }
      } finally {
        if (controller === this.optionRequest) this.selecting = false;
      }
    }
    async addToCart(event) {
      if (!window.fetch || !this.cartDialog?.showModal) return;
      event.preventDefault();
      const form = event.target;
      const button = this.querySelector('[data-add-to-cart]');
      if (this.adding || this.selecting || button.disabled || !form.reportValidity()) return;
      const data = new FormData(form);
      const quantity = Number(data.get('quantity'));
      const label = button.querySelector('span');
      const originalLabel = label.textContent;
      this.adding = true; button.disabled = true;
      this.querySelector('[data-sticky-submit]').disabled = true;
      this.querySelectorAll('input[data-option-value-id],select[data-option-select]').forEach(option => option.disabled = true);
      label.textContent = this.dataset.loadingLabel;
      this.querySelector('[data-product-error]').hidden = true;
      this.querySelector('.sv-pdp__check-cart').hidden = true;
      let succeeded = false;
      try {
        const response = await fetch(this.dataset.cartAddUrl, { method: 'POST', body: data, headers: { Accept: 'application/json' } });
        const result = await response.json();
        if (!response.ok) { this.setError(typeof result.description === 'string' ? result.description : this.dataset.cartError); return; }
        const item = result.items?.[0] || result;
        if (!item.id) throw new Error('Unconfirmed cart response');
        succeeded = true;
        this.querySelector('[data-added-quantity]').textContent = String(quantity);
        this.querySelector('[data-added-variant]').textContent = item.variant_title === 'Default Title' ? '' : item.variant_title || '';
        const cartImage = this.cartDialog.querySelector('.sv-pdp__cart-item>img');
        if (cartImage && item.image) { cartImage.src = item.image; cartImage.removeAttribute('srcset'); }
        this.cartDialog.showModal(); document.body.classList.add('sv-pdp-dialog-open');
        this.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true, detail: { item } }));
        const cartResponse = await fetch(`${this.dataset.cartUrl}.js`, { headers: { Accept: 'application/json' } });
        if (cartResponse.ok) {
          const cart = await cartResponse.json();
          const cartLink = [...document.querySelectorAll('a.sv-icon-button')].find(link => new URL(link.href).pathname === this.dataset.cartUrl);
          if (cartLink && Number.isFinite(cart.item_count)) {
            let badge = cartLink.querySelector('.sv-cart-count');
            if (!badge) { badge = document.createElement('span'); badge.className = 'sv-cart-count'; cartLink.append(badge); }
            badge.textContent = String(cart.item_count); badge.hidden = cart.item_count === 0;
          }
        }
      } catch {
        if (!succeeded) this.setError(this.dataset.cartError, true);
      } finally {
        this.adding = false;
        button.disabled = false; label.textContent = originalLabel;
        this.querySelector('[data-sticky-submit]').disabled = false;
        this.querySelectorAll('input[data-option-value-id],select[data-option-select]').forEach(option => option.disabled = false);
      }
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
